var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',_vm._g(_vm._b({staticClass:"imd-sm-textarea"},'textarea',Object.assign({}, _vm.$attrs, {value: _vm.value}),false),Object.assign({}, _vm.$listeners,
    {input: function (v){ return _vm.$emit('input',v.target.value); }})),[_vm._v("  <slot></slot>\n")])}
var staticRenderFns = []

export { render, staticRenderFns }